import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Cookies from "js-cookie";
import { FetchDataTypes } from "../api/api";
import { MultiSelect } from "react-multi-select-component";
import moment from "moment";
import filter, { concat } from "lodash";
import _ from "lodash";
//import DropdownMultiselect from "react-multiselect-dropdown-bootstrap";

const FundPerformanceChart = () => {
  const [sectorAllocation, setSectorAllocation] = useState<any>(null);
  const [mtdDays, setMtdDays] = useState<any>(null);
  const [setDate, setSetDate] = useState(90);
  const [currentPage, setCurrentPage] = useState(0);
  const [ytdDays, setYtdDays] = useState<any>(null);
  const [selected, setSelected] = useState([]);
  const [isselectedNASDAQComposite, setIsSelectedNASDAQComposite] =
    useState(null);
  const [NASDAQ, setNASDAQ] = useState(false);
  const [first, setfirst] = useState<any>(null);
  const [second, setSecond] = useState<any>(null);
  const [third, setThird] = useState<any>(null);

  const [benchMarkLabel, setBenchMarkLabel] = useState<any>(null);
  const [selectBenchMark, setSelectBenchMark] = useState<any>(null);
  const obj = { indexBenchmarkID: 0, indexBenchmarkName: "Select BenchMark" };
  //var toDate =
  const BeginDate = new Date(Date.now() - 365 * 24 * 60 * 60 * 2000);
  const EndDate = new Date();
  const yfd = new Date(EndDate.getFullYear(), 0, 1);
  const countDays = Math.abs(EndDate.getTime() - yfd.getTime());
  const ytd = countDays / (1000 * 3600 * 24);
  console.log("BeginDate", BeginDate, EndDate);
  const a = moment().isBetween(BeginDate, EndDate);
  const selectedClient:any = Cookies.get("client")
  const [multiSelect, setMultiSelect] = useState<any>([]);
  const [multiSelectCount, setMultiSelectCount] = useState<any>();
  function handleBanchMark(e: any, selectedOptions: any) {
    setSelected(e);
    setMultiSelectCount(e.length);
    if (Array.isArray(e)) {
      const selectedValues: string[] = [];
      e.forEach((selectedOption: { value: number; label: string }) => {
        selectedValues.push(String(selectedOption.value));
      });
      setMultiSelect(selectedValues);
    } else {
      setMultiSelect([String(e.value)]);
    }
  }

  function getFirstDayOfMonth(year: any, month: any) {
    return new Date(year, month, 1);
  }

  const firstDayCurrentMonth = getFirstDayOfMonth(
    EndDate.getFullYear(),
    EndDate.getMonth()
  );
  const mtdCountDays = Math.abs(
    EndDate.getTime() - firstDayCurrentMonth.getTime()
  );
  const MTD = mtdCountDays / (1000 * 3600 * 24);

  const [testData, settestData] = useState(second);
  useEffect(() => {
    FetchDataTypes("FundPerformanceDetails", parseInt(selectedClient),Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        settestData(response);
        console.log(response);
      });
    setCurrentPage(setDate);
  }, [setDate]);

  var filteredDataNew =
    testData &&
    testData.filter((e: any) => {
      var newdate = new Date(e.perfDate);
      return newdate;
    });

  useEffect(() => {
    setYtdDays(ytd.toFixed(0));
    setMtdDays(MTD.toFixed(0));
  }, [ytd, MTD]);

  const filteredDataab = testData?.filter((data: any) => data.fundID === 1);

  const [selectedFund, setSelectedFund] = useState<any>();
  const uniqueOptionsList = _.uniqBy(testData, "fundID");
  var optionsList = uniqueOptionsList?.map((e: any) => ({
    label: e.fundName,
    value: e.fundID, // replace 'id' with the appropriate property name from your testData array
  }));
  // function handleFundName(event:any) {
  //   const selectedOptions = Array.from(event.target.selectedOptions);
  //   const selectedValues = selectedOptions.map((option:any) => option.value);

  //   const filteredData = testData?.filter((data:any) => selectedValues.includes(data.fundID.toString()));
  //   setSelectedFund(filteredData)
  //   console.log(filteredData); // Do something with the filtered data
  // }
  // console.log(selectedFund)

  //const [selectedFunds, setSelectedFunds] = useState<any>([]);

  // function handleFundName(event:any) {
  //   console.log(event)
  //   const selectedOptions = Array.from(event.target.selectedOptions);
  //   const selectedValues = selectedOptions.map((option:any) => option.value);
  //   console.log(selectedValues)
  //   setSelectedFunds(selectedValues);
  // }

  const dataSelectID = multiSelect.length !== 0 ? multiSelect : ["1"];
  console.log(dataSelectID);
  const seriesData = dataSelectID?.map((fundID: any) => {
    const fund = testData?.find(
      (data: any) => data.fundID.toString() === fundID
    );
    const data = testData
      ?.filter((data: any) => data.fundID.toString() === fundID)
      .map((data: any) => data.mtdNet);

    console.log(`Fund ${fundID} data:`, data);

    return {
      marker: { enabled: false },
      name: fund?.fundName + " MTD ",
      type: "spline",
      yAxis: 1,
      data: data || [],
      tooltip: { valueSuffix: "" },
    };
  });
  let options = {
    chart: {
      zoomType: "xy",
      width: 1100,
    },
    title: {
      text: "",
    },
    subtitle: {
      text: "",
    },
    plotOptions: {
      series: {
        lineWidth: 1,
        backgroundColor: "rgb(240,241,248)",
        marker: {
          enabled: false,
        },
        pointWidth: 10,
      },
    },
    xAxis: [
      {
        type: "datetime",
        categories: filteredDataNew
          ?.filter((data: any) =>
            dataSelectID?.includes(data.fundID.toString())
          )
          .map((data: any) => moment(data.perfDate).format("MMM DD YYYY")),
        crosshair: true,
      },
    ],

    yAxis: [
      {
        // Primary yAxis

        title: {
          text: "",
          style: {
            color: "#806E89",
          },
        },
        labels: {
          allowDecimals: true,
          format: "% {value}",
          style: {
            color: "#806E89",
          },
        },
        opposite: false,
      },
      {
        // Secondary yAxis

        title: {
          text: "Performance",
          style: {
            color: "#806E89",
          },
        },
        labels: {
          allowDecimals: true,
          format: "{value} %",
          style: {
            color: "#806E89",
          },
        },
        opposite: false,
      },
    ],
    tooltip: {
      headerFormat: selectedFund?.slice(0, 1).map((item: any) => {
        return `<b>${item.fundName}</b><br />`;
      }),
      shared: true,
    },
    legend: {
      layout: "horizontal",
      align: "center",
      x: 0,
      verticalAlign: "bottom",
      y: 0,
      floating: false,
      backgroundColor: "rgba(255,255,255,0.25)",
      itemMarginTop: 0,
    },
    series: seriesData,
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 1000,
          },
        },
      ],
    },
  };

  return (
    <div className=" w-100">
      <div className="card-header">
        <h5 className="card-title float-start">Fund Performance</h5>

        <div className="float-end mx-4">
          <MultiSelect
            options={optionsList}
            value={selected}
            onChange={handleBanchMark}
            labelledBy={selected.length.toString()}
            className="multiSelect"
            valueRenderer={(selected) => `${selected.length} selected`}
          />
        </div>
        {/* <div className="float-end mx-4">
          <select multiple className="form-control" onChange={handleFundName}>
            <option>Select</option>
            {uniqueOptionsList?.map((e: any) => {
              return <option value={e.fundID}>{e.fundName}</option>;
            })}
          </select>
          
        </div> */}
      </div>

      <div className="card-body d-flex w-100">
        <div className="align-self-center chart chart-lg">
          <div className="chartjs-size-monitor hight-chart">
            <HighchartsReact
              highcharts={Highcharts}
              options={options}
              oneToOne={true}
              width="1000px"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export { FundPerformanceChart };
